<nz-table
  #nzTable
  *ngIf="configuration.columnConfigurations.columns && data"
  [nzData]="data"
  [nzLoading]="isLoading"
  [nzFrontPagination]="configuration?.nzFrontPagination || false"
  [nzSize]="configuration?.nzSize || 'small'"
  [nzScroll]="configuration?.nzScroll || null"
>
  <thead>
    <tr>
      <ng-container
        *ngFor="let column of configuration.columnConfigurations.columns"
      >
        <th
          *ngIf="column.cell.type === 'expand'"
          [nzLeft]="column?.fixedPosition?.nzLeft || false"
          [nzRight]="column?.fixedPosition?.nzRight || false"
          [nzWidth]="column.width ? column.width + 'px' : null"
        ></th>
        <ng-container
          *ngIf="
            column.cell.type !== 'check' &&
            column.cell.type !== 'expand' &&
            column.cell.type !== 'actions'
          "
        >
          <th
            [nzLeft]="column?.fixedPosition?.nzLeft || false"
            [nzRight]="column?.fixedPosition?.nzRight || false"
            [nzWidth]="column.width ? column.width + 'px' : null"
            [nzShowFilter]="
              (column?.filterSettings &&
                !column?.filterSettings?.customFilter) ||
              false
            "
            [nzFilterMultiple]="!column?.filterSettings?.disableMultipleFilter"
            [nzFilters]="column?.filterSettings?.filters || []"
            [nzCustomFilter]="column?.filterSettings?.customFilter || false"
            [nzShowSort]="column?.showSort || false"
            [nzSortOrder]="column?.sortOrder || null"
            (nzFilterChange)="onFilterSubmit(column.property, $event)"
            (nzSortOrderChange)="onSortOrderChange(column.property, $event)"
          >
            <ng-container
              *ngTemplateOutlet="thTemplate; context: { column: column }"
            ></ng-container>
          </th>
        </ng-container>

        <ng-container *ngIf="column.cell.type === 'actions'">
          <ng-container *appAccessCtrl="column.res">
            <th
              [nzLeft]="column?.fixedPosition?.nzLeft || false"
              [nzRight]="column?.fixedPosition?.nzRight || false"
              [nzWidth]="column.width ? column.width + 'px' : null"
              [nzShowFilter]="
                (column?.filterSettings &&
                  !column?.filterSettings?.customFilter) ||
                false
              "
              [nzFilterMultiple]="
                !column?.filterSettings?.disableMultipleFilter
              "
              [nzFilters]="column?.filterSettings?.filters || []"
              [nzCustomFilter]="column?.filterSettings?.customFilter || false"
              [nzShowSort]="column?.showSort || false"
              [nzSortOrder]="column?.sortOrder || null"
              (nzFilterChange)="onFilterSubmit(column.property, $event)"
              (nzSortOrderChange)="onSortOrderChange(column.property, $event)"
            >
              <ng-container
                *ngTemplateOutlet="thTemplate; context: { column: column }"
              ></ng-container>
            </th>
          </ng-container>
        </ng-container>

        <th
          *ngIf="column.cell.type === 'check'"
          [nzLeft]="column?.fixedPosition?.nzLeft || false"
          [nzRight]="column?.fixedPosition?.nzRight || false"
          [nzWidth]="column.width ? column.width + 'px' : null"
          [(nzChecked)]="checked"
          [nzIndeterminate]="indeterminate"
          (nzCheckedChange)="onAllChecked($event)"
        ></th>
      </ng-container>
    </tr>
  </thead>
  <tbody>
    <ng-container *ngFor="let data of nzTable.data; let i = index">
      <tr>
        <ng-container
          *ngFor="let column of configuration.columnConfigurations.columns"
        >
          <ng-container [ngSwitch]="column.cell.type">
            <ng-container *ngSwitchCase="'expand'">
              <td
                [nzShowExpand]="true | ViewComputer: column.cell.viewPipe:data"
                [nzLeft]="column?.fixedPosition?.nzLeft || false"
                [nzRight]="column?.fixedPosition?.nzRight || false"
                [nzExpand]="expandSet.has(i)"
                (nzExpandChange)="onExpandChange(i, $event)"
              ></td>
            </ng-container>
            <ng-container *ngSwitchCase="'tag'">
              <td
                [nzLeft]="column?.fixedPosition?.nzLeft || false"
                [nzRight]="column?.fixedPosition?.nzRight || false"
              >
                <nz-tag
                  [nzColor]="
                    data[column.property] | ViewComputer: column.cell.viewPipe
                  "
                >
                  <ng-container *ngIf="!column.translation.enabled">
                    {{
                      data[column.property]
                        | ValueComputer: column.cell.valuePipe:data
                        | async
                        | translate
                    }}
                  </ng-container>
                  <ng-container *ngIf="column.translation.enabled">
                    <ng-container
                      *ngTemplateOutlet="
                        translateTemplate;
                        context: { column: column, data: data }
                      "
                    ></ng-container>
                  </ng-container>
                </nz-tag>
              </td>
            </ng-container>
            <ng-container *ngSwitchCase="'countryFlag'">
              <td
                [nzLeft]="column?.fixedPosition?.nzLeft || false"
                [nzRight]="column?.fixedPosition?.nzRight || false"
              >
                <span
                  *ngIf="data[column.property]"
                  [class]="
                    'phone-flag iti__flag iti__' +
                    (data[column.property]
                      | ViewComputer: column.cell.viewPipe:data)
                  "
                ></span>
              </td>
            </ng-container>
            <ng-container *ngSwitchCase="'actions'">
              <td
                [nzLeft]="column?.fixedPosition?.nzLeft || false"
                [nzRight]="column?.fixedPosition?.nzRight || false"
              >
                <button
                  nz-button
                  nz-dropdown
                  nzType="link"
                  [nzDropdownMenu]="actionMenu"
                >
                  ...
                </button>
                <nz-dropdown-menu #actionMenu="nzDropdownMenu">
                  <ul nz-menu>
                    <ng-container
                      *ngFor="let action of column.cell.actions"
                      (click)="onActionClick(action.value, data)"
                    >
                      <ng-container *appAccessCtrl="action.res">
                        <ng-container
                          *ngIf="
                            action.viewPipe &&
                            !action.copyProperty &&
                            !action.copyProperty
                          "
                        >
                          <li
                            *ngIf="
                              true
                                | ViewComputer: action.viewPipe:data
                                | translate
                            "
                            nz-menu-item
                            (click)="onActionClick(action.value, data)"
                            [innerHTML]="
                              getStrPath('ACTIONS.' + action.translationKey)
                                | ViewComputer: action.viewPipe:data
                                | translate
                            "
                          ></li>
                        </ng-container>
                      </ng-container>
                      <ng-container
                        *ngIf="
                          action.copyProperty &&
                          action.copiedText &&
                          data[action.copyProperty]
                        "
                      >
                        <ng-container *appAccessCtrl="action.res">
                          <li nz-menu-item>
                            <ng-container
                              *ngTemplateOutlet="
                                actionCopyTpl;
                                context: { action: action, data: data }
                              "
                            ></ng-container>
                          </li>
                        </ng-container>
                      </ng-container>
                      <ng-container
                        *ngIf="
                          !action.viewPipe &&
                          !action.copyProperty &&
                          !action.copiedText &&
                          !action.childActions
                        "
                      >
                        <ng-container *appAccessCtrl="action.res">
                          <li
                            nz-menu-item
                            (click)="onActionClick(action.value, data)"
                          >
                            {{
                              getStrPath("ACTIONS." + action.translationKey)
                                | translate
                            }}
                          </li>
                        </ng-container>
                      </ng-container>
                      <ng-container
                        *ngIf="
                          !action.viewPipe &&
                          !action.copyProperty &&
                          !action.copiedText &&
                          action.childActions
                        "
                      >
                        <ng-container *appAccessCtrl="action.res">
                          <li
                            nz-submenu
                            [nzTitle]="
                              getStrPath('ACTIONS.' + action.translationKey)
                                | translate
                            "
                            (click)="onActionClick(action.value, data)"
                          >
                            <ul *ngIf="action.childActions?.length">
                              <ng-container
                                *ngFor="let childAction of action.childActions"
                              >
                                <li
                                  *ngIf="
                                    true
                                      | ViewComputer
                                        : childAction.value.viewPipe
                                        : data
                                      | translate
                                  "
                                  nz-menu-item
                                  (click)="
                                    onActionClick(childAction.value, data)
                                  "
                                  [innerHTML]="
                                    getStrPath(
                                      'ACTIONS.' + childAction.translationKey
                                    )
                                      | ViewComputer: childAction.viewPipe:data
                                      | translate
                                  "
                                ></li>
                              </ng-container>
                            </ul>
                          </li>
                        </ng-container>
                      </ng-container>
                    </ng-container>
                  </ul>
                </nz-dropdown-menu>
              </td>
            </ng-container>
            <ng-container *ngSwitchCase="'check'">
              <td
                [nzLeft]="column?.fixedPosition?.nzLeft || false"
                [nzRight]="column?.fixedPosition?.nzRight || false"
                [nzChecked]="data.isChecked"
                (nzCheckedChange)="onItemCheck(data, $event)"
              ></td>
            </ng-container>
            <ng-container *ngSwitchCase="'icon'">
              <td
                [nzLeft]="column?.fixedPosition?.nzLeft || false"
                [nzRight]="column?.fixedPosition?.nzRight || false"
              >
                <div [innerHTML]="data.icon"></div>
              </td>
            </ng-container>
            <ng-container *ngSwitchCase="'input'">
              <td
                [nzLeft]="column?.fixedPosition?.nzLeft || false"
                [nzRight]="column?.fixedPosition?.nzRight || false"
              >
                <ng-container
                  *ngIf="
                    column.cell.input?.type === 'number';
                    else defaultInput
                  "
                >
                  <nz-input-number
                    *ngIf="
                      !column.cell.hideContent?.values?.includes(
                        data[column.cell.hideContent?.property]
                      )
                    "
                    [nzMin]="
                      column.cell.input?.nzMin !== undefined
                        ? column.cell.input?.nzMin
                        : Number.NEGATIVE_INFINITY
                    "
                    [nzMax]="
                      column.cell.input?.nzMax !== undefined
                        ? column.cell.input?.nzMax
                        : Number.POSITIVE_INFINITY
                    "
                    [nzStep]="
                      column.cell.input?.nzStep !== undefined
                        ? column.cell.input?.nzStep
                        : 1
                    "
                    [nzDisabled]="data.disabled"
                    [ngModel]="data[column.property]"
                    (input)="
                      onCellInputValueChange(
                        data,
                        column.property,
                        +inputNumberEl.inputElement?.nativeElement?.value
                      )
                    "
                    (focusout)="
                      onCellInputValueChange(
                        data,
                        column.property,
                        +inputNumberEl.inputElement?.nativeElement?.value
                      )
                    "
                    (mouseup)="
                      onCellInputValueChange(
                        data,
                        column.property,
                        +inputNumberEl.inputElement?.nativeElement?.value,
                        $event
                      )
                    "
                    #inputNumberEl
                  >
                  </nz-input-number>
                </ng-container>
                <ng-template #defaultInput>
                  <input
                    nz-input
                    [type]="column.cell.input?.type"
                    [disabled]="data.disabled"
                    [value]="data[column.property]"
                    (input)="
                      onCellInputValueChange(
                        data,
                        column.property,
                        $event.target.value
                      )
                    "
                    (focusout)="
                      onCellInputValueChange(
                        data,
                        column.property,
                        $event.target.value
                      )
                    "
                  />
                </ng-template>
              </td>
            </ng-container>
            <ng-container *ngSwitchDefault>
              <td
                [nzLeft]="column?.fixedPosition?.nzLeft || false"
                [nzRight]="column?.fixedPosition?.nzRight || false"
              >
                <ng-container
                  *ngIf="
                    !column.cell.hideContent?.values?.includes(
                      data[column.cell.hideContent?.property]
                    )
                  "
                >
                  <ng-container
                    *ngTemplateOutlet="
                      translateTemplate;
                      context: { column: column, data: data }
                    "
                  ></ng-container>
                </ng-container>
              </td>
            </ng-container>
          </ng-container>
        </ng-container>
      </tr>
      <tr [nzExpand]="expandSet.has(i)">
        <div
          nz-row
          class="box"
          nzType="flex"
          nzJustify="space-between"
          nzAlign="strech"
        >
          <ng-container
            *ngTemplateOutlet="
              configuration.columnConfigurations.expandTplRef;
              context: { $implicit: data }
            "
          >
          </ng-container>
        </div>
      </tr>
    </ng-container>
  </tbody>
</nz-table>

<ng-template #thTemplate let-column="column">
  <ng-container
    *ngTemplateOutlet="translateTemplateTitle; context: { column: column }"
  ></ng-container>
  <nz-filter-trigger
    [nzDropdownMenu]="menu"
    *ngIf="column?.filterSettings?.customFilter"
  >
    <i nz-icon nzType="search" nzTheme="outline"></i>
  </nz-filter-trigger>
  <nz-dropdown-menu #menu="nzDropdownMenu">
    <ul nz-menu>
      <div class="search-box">
        <input
          type="text"
          nz-input
          [placeholder]="
            column?.filterSettings?.customFilterPlaceHolder ||
              'GENERAL.GENERIC_TABLE.COLUMNS.CUSTOM_FILTER_PLACEHOLDER'
              | translate
          "
          #inpSearch
        />
        <button
          nz-button
          nzSize="small"
          nzType="primary"
          (click)="onCustomFilterSubmit(column, inpSearch.value)"
          class="search-button"
        >
          {{
            "GENERAL.GENERIC_TABLE.COLUMNS.CUSTOM_FILTER_SEARCHBUTTON"
              | translate
          }}
        </button>
        <button
          nz-button
          nzSize="small"
          (click)="onCustomFilterReset(column, inpSearch)"
        >
          {{
            "GENERAL.GENERIC_TABLE.COLUMNS.CUSTOM_FILTER_RESETBUTTON"
              | translate
          }}
        </button>
      </div>
    </ul>
  </nz-dropdown-menu>
</ng-template>

<ng-template #translateTemplate let-column="column" let-data="data">
  <ng-container
    *ngIf="!column.translation.customPath; else customTranslatePath"
  >
    <ng-container *ngIf="!column.translation.enabled">
      <span
        [innerHTML]="
          data[column.property]
            | ValueComputer: column.cell.valuePipe:data
            | async
        "
      ></span>
    </ng-container>
    <ng-container *ngIf="column.translation.enabled">
      {{
        getStrPath(column.translation.key + "." + data[column.property])
          | ValueComputer: column.cell.valuePipe:data
          | async
          | translate
      }}
    </ng-container>
    <ng-container
      *ngTemplateOutlet="
        cellTooltipTemplate;
        context: { translationPath: column.translation.key }
      "
    ></ng-container>
  </ng-container>

  <ng-template #customTranslatePath>
    <ng-container *ngIf="!column.translation.enabled">
      <ng-container *ngIf="data[column.property]">
        {{
          data[column.property]
            | ValueComputer: column.cell.valuePipe:data
            | async
        }}
      </ng-container>
      <ng-container *ngIf="!data[column.property]"> N/A </ng-container>
    </ng-container>
    <ng-container *ngIf="column.translation.enabled">
      <ng-container
        *ngTemplateOutlet="
          cellTooltipTemplate;
          context: { translationPath: column.translation.customPath }
        "
      ></ng-container>
      <ng-container *ngIf="data[column.property]">
        {{
          column.translation.customPath + "." + data[column.property]
            | ValueComputer: column.cell.valuePipe:data
            | async
            | translate
        }}
      </ng-container>
      <ng-container *ngIf="!data[column.property]"> N/A </ng-container>
    </ng-container>
    <ng-container
      *ngTemplateOutlet="
        cellTooltipTemplate;
        context: { translationPath: column.translation.customPath }
      "
    ></ng-container>
  </ng-template>

  <ng-template #cellTooltipTemplate let-translationPath="translationPath">
    <!-- Show tooltip icon in specific cells -->
    <nz-form-label
      *ngIf="
        !column.translation.customPath &&
        column.cell.tooltip &&
        data[column.cell.tooltip]
      "
      [nzTooltipTitle]="
        getStrPath(translationPath + '.' + data[column.cell.tooltip])
          | translate
      "
    >
    </nz-form-label>
    <nz-form-label
      *ngIf="
        column.translation.customPath &&
        column.cell.tooltip &&
        data[column.cell.tooltip]
      "
      [nzTooltipTitle]="
        translationPath + '.' + data[column.cell.tooltip] | translate
      "
    >
    </nz-form-label>
  </ng-template>
</ng-template>

<ng-template #actionCopyTpl let-data="data" let-action="action">
  <span
    nz-typography
    nzCopyable
    [nzCopyText]="data[action.copyProperty]"
    [nzCopyTooltips]="null"
    [nzCopyIcons]="[copyButtonTpl, copiedButtonTpl]"
  ></span>

  <ng-template #copyButtonTpl>
    <span class="copy-button">
      <span class="copy-button-text">
        {{ getStrPath("ACTIONS.DROPDOWN." + action.value) | translate }}
      </span>
      <i class="fal fa-copy"></i>
    </span>
  </ng-template>

  <ng-template #copiedButtonTpl>
    <span>
      <span class="copy-button-text">
        {{ getStrPath("ACTIONS.DROPDOWN." + action.copiedText) | translate }}
      </span>
      <i class="fal fa-check"></i>
    </span>
  </ng-template>
</ng-template>

<ng-template #translateTemplateTitle let-column="column">
  <ng-container
    *ngIf="!column.translation.customPath; else customTranslatePath"
  >
    {{ getStrPath(column.translation.key + ".TITLE") | translate }}
  </ng-container>
  <ng-template #customTranslatePath>
    {{ column.translation.customPath + ".TITLE" | translate }}
  </ng-template>
</ng-template>
